export default __webpack_public_path__ + "c6c15d1b7cc570a0eae86f5b29bee1cd.svg";